import { Badge } from "@mantine/core";

export default {
  Badge: Badge.extend({
    defaultProps: {
      radius: "md",
    },
  }),
};
